import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
  InputAdornment,
  Checkbox,
  FormControlLabel,
  PopoverPaper,
  Button,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import InputMask from "react-input-mask";
import { FormHelperText } from "@mui/material";
import { getData, getCodeArg } from "../../../../../services/library";
import { verificarCuit, verificarDni } from "../../validaciones";
import ErrorDialog from "../../../../Dialogs/ErrorDialog";

function FormNuevoCliente(props) {
  const [dataCliente, setDataCliente] = useState({
    tipo_doc_afip: 80,
  });
  const [codArg, setCodArg] = useState();
  const [sucursales, setSucursales] = useState(null);
  const [empresas, setEmpresas] = useState(null);
  const [localidades, setLocalidades] = useState(null);
  const [comerciales, setComerciales] = useState(null);
  const [segmentos, setSegmentos] = useState(null);
  const [subsegmentos, setSubsegmentos] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [condiciones, setCondiciones] = useState(null);
  const [categorias, setCategorias] = useState(null);
  const [sitIva, setSitIva] = useState(null);
  const [tipoCliente, setTipoCliente] = useState(null);
  const [unidadesFact, setUnidadesFact] = useState(null);
  const [errorDialog, setErrorDialog] = useState(false);
  const [convenios, setConvenios] = useState();

  // Variables o estados que manejan componentes visuales
  const size = "small";
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  console.log(props.dataNuevoCliente)

  //--------------------- FUNCIONES ---------------------//
  //Obtengo por única vez al momento de carga del componente y mediante llamadas a la api, los siguientes datos necesarios para rellenar el formulario:
  useEffect(() => {
    getData("/categorias", setCategorias);
    getData("/representantes/activos", setComerciales);
    getData("/segmentos", setSegmentos);
    getData("/provincias", setProvincias);
    getData("/condicion_pago", setCondiciones);
    getData("/condiciones_iva/activos", setSitIva);
    getData("/convenios", setConvenios);
    getData("/tipocliente", setTipoCliente);
    getCodeArg(setCodArg);
    getData("/desplegables/unidadFact", setUnidadesFact);
    getData("/empresas/granel", setEmpresas);
    getData(
      "/sucursales/empresayotra/" + props.dataNuevoCliente.id_empresa,
      setSucursales
    );

    //BORRAR OPRQUE ES INNECESARIO:
    getData(
      "/localidades/prov/" + props.dataNuevoCliente.id_provincia,
      setLocalidades
    );
  }, []);

  const almacenar = (e) => {
    props.setDataNuevoCliente({
      ...props.dataNuevoCliente,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div>
      <form onSubmit={props.armar}>
        <Grid
          container
          spacing={1}
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
          alignContent="center"
          wrap="wrap"
          p={2}
        >
          <Grid item xs={8}>
            <TextField
              required
              size={props.size}
              autoFocus
              label="Razon Social"
              fullWidth
              type="text"
              name="razon_social"
              onChange={almacenar}
              value={
                props.dataNuevoCliente.razon_social &&
                props.dataNuevoCliente.razon_social.replace(/\b\w/g, (l) =>
                  l.toUpperCase()
                )
              }
              inputProps={{ maxLength: 200 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <FormControl fullWidth size={props.size} disabled>
              <InputLabel> Tipo Cliente</InputLabel>
              <Select
                label="Tipo Cliente"
                name="id_tipocliente"
                value={props.dataNuevoCliente.id_tipocliente}
                onChange={(e) => {
                  almacenar(e);
                }}
              >
                {tipoCliente
                  ? tipoCliente.map((elemento) => (
                    <MenuItem
                      key={elemento.idtipocliente}
                      value={elemento.idtipocliente}
                    >
                      {elemento.nombre}
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={2}>
            <TextField
              size={props.size}
              label="Sisven ID"
              type="text"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              inputProps={{ maxLength: 6 }} //solo 2 numeros
              name="sisven_id"
              disabled
              onChange={almacenar}
              value={props.dataNuevoCliente.sisven_id}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MeetingRoomIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={3}>
            <FormControl size={props.size} fullWidth required>
              <InputLabel>Cuit/Dni</InputLabel>
              <Select
                name="tipo_doc_afip"
                labelId="Cuit/Dni"
                value={props.dataNuevoCliente.tipo_doc_afip}
                label="Sucursal"
                onChange={almacenar}
              >
                <MenuItem key={"cuit"} value={80}>
                  Cuit
                </MenuItem>
                <MenuItem key={"dni"} value={96}>
                  Dni
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {props.dataNuevoCliente.tipo_doc_afip === 80 ? (
            <Grid item xs={3}>
              <InputMask
                mask="99-99999999-9"
                value={props.dataNuevoCliente.cuit}
                disabled={false}
                maskChar=" "
                fullWidth
                onChange={(e) =>
                  props.setDataNuevoCliente({
                    ...props.dataNuevoCliente,
                    cuit: e.target.value,
                  })
                }
                onBlur={(e) =>
                  verificarCuit(
                    props.dataNuevoCliente,
                    props.setDataNuevoCliente,
                    setErrorDialog
                  )
                }
              >
                {() => (
                  <TextField
                    fullWidth
                    required={props.dataNuevoCliente.tipo_doc_afip === 80}
                    size={props.size}
                    defaultValue=""
                    type="text"
                    name="cuit"
                    label="Numero Cuit"
                  />
                )}
              </InputMask>
            </Grid>
          ) : (
            <Grid item xs={3}>
              <InputMask
                mask="99.999.999"
                value={props.dataNuevoCliente.cuit}
                maskChar=" "
                onChange={(e) =>
                  props.setDataNuevoCliente({
                    ...props.dataNuevoCliente,
                    cuit: e.target.value,
                  })
                }
                onBlur={(e) =>
                  verificarDni(
                    props.dataNuevoCliente,
                    props.setDataNuevoCliente,
                    setErrorDialog
                  )
                }
              >
                {() => (
                  <TextField
                    required={props.dataNuevoCliente.tipo_doc_afip === 96}
                    fullWidth
                    size={props.size}
                    defaultValue=""
                    type="text"
                    name="cuit"
                    label="Numero Dni"
                  />
                )}
              </InputMask>
            </Grid>
          )}

          <Grid item xs={3}>
            <FormControl fullWidth size={props.size} required>
              <InputLabel>Condición de pago</InputLabel>
              <Select
                name="id_condicionpago"
                labelId="id_condicionpago"
                value={props.dataNuevoCliente.id_condicionpago}
                label="Condición de pago"
                onChange={almacenar}
              >
                {condiciones
                  ? condiciones.map((elemento) => (
                    <MenuItem key={elemento.id} value={elemento.id}>
                      {elemento.condicion}
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={3}>
            <FormControl required style={style} size={props.size}>
              <InputLabel> Situacion Iva</InputLabel>
              <Select
                label="Situacion Iva"
                name="situacion_iva"
                value={props.dataNuevoCliente.situacion_iva}
                // onChange={almacenar}
                onChange={(e) => {
                  props.setDataNuevoCliente({
                    ...props.dataNuevoCliente, 
                    situacion_iva: e.target.value,
                    id_convenio: null,
                    iibb_nro_inscripcion: ""
                  })
                }}
              >
                {sitIva
                  ? sitIva.map((elemento) => (
                    <MenuItem key={elemento.id} value={elemento.id}>
                      {elemento.descripcion}
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </Grid>


          {sitIva && sitIva.find((reg) => reg.id == props.dataNuevoCliente.situacion_iva)?.inscripcion_iibb ? (
            <>
            <Grid item xs={props.dataNuevoCliente.situacion_iva == 1 ? 6 : 8}>
              <FormControl
                style={style}
                size="small"
                variant="outlined"
                required
              >
                <InputLabel>Sit. Frente a IIBB</InputLabel>
                <Select
                  required
                  label="Sit. Frente a IIBB"
                  name="id_convenio"
                  value={props.dataNuevoCliente.id_convenio}
                  onChange={almacenar}
                >
                  {convenios && convenios.length > 0 && props.dataNuevoCliente.situacion_iva &&
                    convenios
                      .filter((convenio) => {
                        try {
                          const config = JSON.parse(convenio.config);
                          if (!config.cond_iva_permitida) return false;
                          const ivasPermitidos = config.cond_iva_permitida.split(',').map(item => item.trim());
                          return ivasPermitidos.includes(String(props.dataNuevoCliente.situacion_iva));
                        } catch (e) {
                          return false;
                        }
                      })
                      .map((conv) => (
                        <MenuItem key={conv.id_convenio} value={conv.id_convenio}>
                          {conv.convenio}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={props.dataNuevoCliente.situacion_iva == 1 ? 3 : 4 }>
                <InputMask
                  mask={convenios && props.dataNuevoCliente.id_convenio ? JSON.parse(convenios.find(c => c.id_convenio === props.dataNuevoCliente.id_convenio)?.config)?.formato : ""}
                  value={props.dataNuevoCliente.iibb_nro_inscripcion}
                  // disabled={!props.edicionIlimitada}
                  maskChar=" "
                  onChange={almacenar}
                >
                  {() => (
                    <TextField
                      value={props.dataNuevoCliente.iibb_nro_inscripcion}
                      // disabled={!props.edicionIlimitada}
                      size="small"
                      style={style}
                      type="text"
                      focused
                      name="iibb_nro_inscripcion"
                      label="Nro. IIBB"
                    />
                  )}
                </InputMask>
              </Grid>

            </>

          ) : (null)}






          {parseInt(props.dataNuevoCliente.situacion_iva) === 1 && (
            <Grid item xs={3} >
              <FormControlLabel
                sx={{ "& .MuiFormControlLabel-label": { fontSize: 16 } }}
                style={{ fontSize: 16 }}
                labelPlacement="center"
                control={
                  <Checkbox
                    sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}
                    color="primary"
                    // disabled={readOnly}
                    checked={props.dataNuevoCliente.facturacion_especial === 1}
                    onChange={(e) =>
                      props.setDataNuevoCliente({
                        ...props.dataNuevoCliente,
                        facturacion_especial: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                }
                label="FACTURACIÓN ESPECIAL"
              />
            </Grid>
          )}


          <Grid item xs={6}>
            <TextField
              size={props.size}
              fullWidth
              required
              placeholder="Direccion Fiscal"
              name="direccion_fiscal"
              label="Direccion Fiscal"
              color="primary"
              value={
                props.dataNuevoCliente.direccion_fiscal &&
                props.dataNuevoCliente.direccion_fiscal.replace(/\b\w/g, (l) =>
                  l.toUpperCase()
                )
              }
              onChange={almacenar}
              inputProps={{ maxLength: 120 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LocationOnIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>




          {/* <Grid item xs={2}>
            <FormControl required fullWidth size={props.size}>
              <InputLabel>Categoría Crediticia</InputLabel>
              <Select
                name="id_categoria"
                value={props.dataNuevoCliente.id_categoria}
                label="Categoria crediticia"
                onChange={almacenar}
              >
                {categorias
                  ? categorias.map((elemento) => (
                      <MenuItem key={elemento.id} value={elemento.id}>
                        {elemento.categoria} ({elemento.descripcion})
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </Grid> */}

          {/* <Grid item xs={3}>
            <TextField
              size={props.size}
              fullWidth
              placeholder="100000"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              inputProps={{ maxLength: 9 }} //solo 2 numeros
              name="limite_credito"
              label="Límite de crédito"
              color="primary"
              onChange={almacenar}
              value={dataCliente.limite_credito}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </Grid> */}

          <Grid item xs={3}>
            <FormControl required fullWidth size={props.size}>
              <InputLabel> Provincia </InputLabel>
              <Select
                style={{ backgroundColor: "#FFFFFF" }}
                label="Provincia"
                color="primary"
                name="id_provincia"
                value={props.dataNuevoCliente.id_provincia}
                onChange={(e) => {
                  props.setDataNuevoCliente({
                    ...props.dataNuevoCliente,
                    id_provincia: e.target.value,
                    id_localidad: "",
                  });
                  getData(
                    "/localidades/prov/" + e.target.value,
                    setLocalidades
                  );
                }}
              >
                {provincias
                  ? provincias.map((elemento) => (
                    <MenuItem key={elemento.id} value={elemento.id}>
                      {elemento.provincia}
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <FormControl required fullWidth size={props.size}>
              <InputLabel>Localidad</InputLabel>
              <Select
                style={{ backgroundColor: "#FFFFFF" }}
                label="Localidad"
                name="id_localidad"
                value={props.dataNuevoCliente.id_localidad}
                onChange={almacenar}
              >
                {localidades
                  ? localidades.map((elemento) => (
                    <MenuItem key={elemento.id} value={elemento.id}>
                      {elemento.localidad}
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={3}>
            <FormControl required fullWidth size={props.size}>
              <InputLabel>Empresa</InputLabel>
              <Select
                name="id_empresa"
                value={props.dataNuevoCliente.id_empresa}
                label="Empresa"
                onChange={(e) => {
                  props.setDataNuevoCliente({
                    ...props.dataNuevoCliente,
                    id_empresa: e.target.value,
                    id_sucursal: "",
                  });
                  getData(
                    "/sucursales/empresayotra/" + e.target.value,
                    setSucursales
                  );
                }}
              >
                {empresas
                  ? empresas.map((elemento) => (
                    <MenuItem
                      key={elemento.idempresa}
                      value={elemento.idempresa}
                    >
                      {elemento.empresa}
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={3}>
            <FormControl required fullWidth size={props.size}>
              <InputLabel>Sucursal</InputLabel>
              <Select
                style={{ backgroundColor: "#FFFFFF" }}
                name="id_sucursal"
                value={props.dataNuevoCliente.id_sucursal}
                label="Sucursal"
                onChange={almacenar}
              >
                {sucursales
                  ? sucursales.map((elemento) => (
                    <MenuItem key={elemento.id} value={elemento.id}>
                      {elemento.nombre}
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={3}>
            <FormControl required fullWidth size={props.size}>
              <InputLabel>Segmento</InputLabel>
              <Select
                style={{ backgroundColor: "#FFFFFF" }}
                label="Segmento"
                name="id_segmento"
                value={props.dataNuevoCliente.id_segmento}
                onChange={(e) => {
                  props.setDataNuevoCliente({
                    ...props.dataNuevoCliente,
                    id_segmento: e.target.value,
                    id_subsegmento: "",
                  });
                  getData(
                    "/subsegmentos/seg/" + e.target.value,
                    setSubsegmentos
                  );
                }}
              >
                {segmentos
                  ? segmentos.map((elemento) => (
                    <MenuItem key={elemento.id} value={elemento.id}>
                      {elemento.segmento}
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </Grid>

          {/* <Grid item xs={3}>
            <FormControl fullWidth size={props.size}>
              <InputLabel>Subsegmento</InputLabel>
              <Select
                style={{ backgroundColor: "#FFFFFF" }}
                label="Subsegmento"
                name="id_subsegmento"
                value={props.dataNuevoCliente.id_subsegmento}
                onChange={almacenar}
              >
                {subsegmentos
                  ? subsegmentos.map((elemento) => (
                      <MenuItem key={elemento.id} value={elemento.id}>
                        {elemento.subsegmento} - {elemento.codigo_subsegmento}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </Grid> */}

          <Grid item xs={3}>
            <FormControl fullWidth size={props.size} required>
              <InputLabel>Factura En</InputLabel>
              <Select
                label="Factura En"
                style={style}
                name="unidad_fact"
                value={props.dataNuevoCliente.unidad_fact}
                onChange={(e) => {
                  almacenar(e);
                }}
              >
                {unidadesFact
                  ? unidadesFact.map((elemento) => (
                    <MenuItem key={elemento.id} value={elemento.id}>
                      {elemento.valor}
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </Grid>


          <Grid item xs={6}>
            <TextField
              size={props.size}
              required
              placeholder="Mails"
              fullWidth
              name="mails"
              label="Mails"
              color="primary"
              value={props.dataNuevoCliente.mails}
              onChange={almacenar}
              inputProps={{ maxLength: 500 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <ContactMailIcon />
                  </InputAdornment>
                ),
              }}
            />
            <FormHelperText sx={{ bgcolor: "#fff", color: "#5D6D7E" }}>
              Para añadir más de un correo, sepárelos con ; (punto y coma)
            </FormHelperText>
          </Grid>
          <Grid item xs={2}>
            <FormControl fullWidth>
              <TextField
                size={props.size}
                style={{ backgroundColor: "#fff" }}
                fullWidth
                type="text"
                color="primary"
                placeholder="Telefono 1"
                name="telefono1"
                label="Telefono 1"
                value={props.dataNuevoCliente.telefono1}
                onChange={almacenar}
                inputProps={{
                  maxLength: 10,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{codArg}</InputAdornment>
                  ),
                }}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <FormHelperText sx={{ bgcolor: "#fff", color: "#5D6D7E" }}>
                "Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <FormControl fullWidth>
              <TextField
                size={props.size}
                style={{ backgroundColor: "#fff" }}
                fullWidth
                type="text"
                color="primary"
                placeholder="Telefono 2"
                name="telefono2"
                label="Telefono 2"
                value={props.dataNuevoCliente.telefono2}
                onChange={almacenar}
                inputProps={{
                  maxLength: 10,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{codArg}</InputAdornment>
                  ),
                }}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <FormHelperText sx={{ bgcolor: "#fff", color: "#5D6D7E" }}>
                "Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <FormControl fullWidth>
              <TextField
                size={props.size}
                fullWidth
                type="text"
                color="primary"
                placeholder="Telefono 3"
                name="telefono3"
                label="Telefono 3"
                onChange={almacenar}
                value={props.dataNuevoCliente.telefono3}
                inputProps={{
                  maxLength: 10,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{codArg}</InputAdornment>
                  ),
                }}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
              />
              <FormHelperText sx={{ bgcolor: "#fff", color: "#5D6D7E" }}>
                "Cód área (sin 0) + número sin el 15. Ej:341xxxxxx "
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl required fullWidth size={props.size}>
              <InputLabel>Comercial</InputLabel>
              <Select
                style={{ backgroundColor: "#FFFFFF" }}
                label="Comercial"
                name="id_comercial"
                value={props.dataNuevoCliente.id_comercial}
                onChange={almacenar}
              >
                {comerciales
                  ? comerciales.map((elemento) => (
                    <MenuItem key={elemento.id} value={elemento.id}>
                      {elemento.nombre_apellido}
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </Grid>

          {/* <Grid item xs={12}>
            <TextField
              size={props.size}
              label="Observaciones"
              fullWidth
              type="text"
              name="observaciones"
              onChange={almacenar}
              value={props.dataNuevoCliente.observaciones}
              inputProps={{ maxLength: 200 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle />
                  </InputAdornment>
                ),
              }}
            />
          </Grid> */}

          <Grid item xs={3} >
            <FormControlLabel
              sx={{ "& .MuiFormControlLabel-label": { fontSize: 16 } }}
              style={{ fontSize: 16 }}
              labelPlacement="center"
              control={
                <Checkbox
                  sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}
                  // disabled={readOnly}
                  checked={props.dataNuevoCliente.pesada_cliente === 1}
                  onChange={(e) =>
                    props.setDataNuevoCliente({
                      ...props.dataNuevoCliente,
                      pesada_cliente: e.target.checked ? 1 : 0,
                    })
                  }
                />
              }
              label="PESADA CLIENTE"
            />
          </Grid>
          <Grid item xs={3} >
            <FormControlLabel
              sx={{ "& .MuiFormControlLabel-label": { fontSize: 16 } }}
              style={{ fontSize: 16 }}
              labelPlacement="center"
              control={
                <Checkbox
                  sx={{ "& .MuiSvgIcon-root": { fontSize: 24 } }}
                  // disabled={readOnly}
                  checked={props.dataNuevoCliente.precio_especial === 1}
                  onChange={(e) =>
                    props.setDataNuevoCliente({
                      ...props.dataNuevoCliente,
                      precio_especial: e.target.checked ? 1 : 0,
                    })
                  }
                />
              }
              label="PRECIO ESPECIAL"
            />
          </Grid>


          <Grid
            container
            direction="row"
            xs={12}
            justifyContent="flex-end"
            alignItems="center"
            mt={2}
          >
            <Button
              disabled={props.disBtn}
              variant="contained"
              color="success"
              type="submit"
            >
              {props.btnTxt}
            </Button>
          </Grid>
        </Grid>
      </form>
      {errorDialog && (
        <ErrorDialog
          open={errorDialog}
          setOpen={setErrorDialog}
          title={"CLIENTE EXISTENTE"}
          subtitle={
            "El CUIT/DNI que intenta ingresar YA FUE REGISTRADO bajo otra razón social. Revise el listado de clientes."
          }
        />
      )}
    </div>
  );
}

export default FormNuevoCliente;
